
export default {
  props: {
    lastMatch: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
    };
  },
  computed: {
    homeTeam () {
      if (this.lastMatch) {
        return this.getTeam(this.lastMatch);
      }
      return null;
    },
    awayTeam () {
      if (this.lastMatch) {
        return this.getTeam(this.lastMatch, `Away`);
      }
      return null;
    },
    homeTeamScore () {
      return this.homeTeam?.score || ``;
    },
    awayTeamScore () {
      return this.awayTeam?.score || ``;
    },
  },
};
